import { InitialDataResponse } from './models'

class CmsDataService {
    private data: InitialDataResponse
    set(data: InitialDataResponse) {
        this.data = data
    }
    get(): InitialDataResponse {
        return this.data
    }

    captchaEnabled() {
        return this.data && this.data.captcha && this.data.captcha.siteKey
    }
}

export const cmsDataService = new CmsDataService()
